<div *ngIf="loaded">
<app-upload-pending-documents 
[pendingDocumentMetaData] = "pendingDocumentMetaData"
(documentResult)="updateDocumentDetails($event)">
</app-upload-pending-documents>
</div>
